import api from "@/api";

// ====== 枚举（按 galaxy 原值复刻）======
export const LogicalOperators = {
    AND: "and",
    OR: "or"
};

export const CompareOperators = {
    EQUAL: "eq",
    NOT_EQUAL: "ne",
    BETWEEN: "between",
    GREATER_THAN_OR_EQUAL: "gte"
};

export const ConditionsTypeEnum = {
    OPERATOR: 1,
    DATA: 2
};

export const ConditionsDataTypeEnum = {
    USER: "uid",
    // USER_ROLE: "userRole",
    // CHANNEL: "channel",
    // APP_VERSION: "version",
    // USAGE_DAY: "usageDay"
};

export const LogicalOperatorsMap = {
    [LogicalOperators.AND]: "且",
    [LogicalOperators.OR]: "或"
};

export const CompareOperatorsMap = {
    [CompareOperators.EQUAL]: "等于",
    [CompareOperators.NOT_EQUAL]: "不等于",
    [CompareOperators.BETWEEN]: "区间",
    [CompareOperators.GREATER_THAN_OR_EQUAL]: "大于等于"
};

export const ConditionsDataTypeMap = {
    [ConditionsDataTypeEnum.CHANNEL]: "渠道",
    [ConditionsDataTypeEnum.USER_ROLE]: "用户角色",
    [ConditionsDataTypeEnum.USER]: "指定人群",
    [ConditionsDataTypeEnum.APP_VERSION]: "App版本",
    [ConditionsDataTypeEnum.USAGE_DAY]: "使用天数"
};

const createPushConditionsData = (hasLogicalOperator) => ({
    tempSelectModel: "all",
    tempUsers: "",
    tempLogicalOperator: hasLogicalOperator
        ? {
            type: ConditionsTypeEnum.OPERATOR,
            dataType: "",
            operator: LogicalOperators.AND,
            group: "",
            name: "",
            values: []
        }
        : null,
    pushConditions: {
        type: ConditionsTypeEnum.DATA,
        dataType: ConditionsDataTypeEnum.USER,
        operator: CompareOperators.EQUAL,
        group: "",
        name: "",
        values: []
    }
});

export function createPushConditionsStore(vm) {
    const store = vm;
    store.pushConditionsConfig = {};
    store.pushConditionsData = [createPushConditionsData(false)];

    store.initPushConditionsData = (data) => {
        store.pushConditionsData = [];
        let temp = null;
        (data || []).forEach((item) => {
            if (item.type === ConditionsTypeEnum.OPERATOR) {
                temp = createPushConditionsData(true);
                temp.tempLogicalOperator = { ...item };
            } else if (item.type === ConditionsTypeEnum.DATA) {
                if (!temp) temp = createPushConditionsData(false);
                temp.pushConditions = item;
                temp.tempSelectModel = item.values && item.values.length ? "specified" : "all";
                temp.tempUsers = item.dataType === ConditionsDataTypeEnum.USER ? (item.values || []).join(";") : "";
                store.pushConditionsData.push(temp);
                temp = null;
            }
        });
        if (!store.pushConditionsData.length) {
            store.pushConditionsData = [createPushConditionsData(false)];
        }
        // 第一个不允许有逻辑符
        store.pushConditionsData[0].tempLogicalOperator = null;
    };

    store.addPushConditionsData = () => {
        store.pushConditionsData.push(createPushConditionsData(true));
    };

    store.deletePushConditionsData = (index) => {
        store.pushConditionsData.splice(index, 1);
        if (store.pushConditionsData.length) {
            store.pushConditionsData[0].tempLogicalOperator = null;
        } else {
            store.pushConditionsData = [createPushConditionsData(false)];
        }
    };

    store.getConditionsData = () => {
        const conditions = [];
        store.pushConditionsData.forEach((item) => {
            if (item.tempLogicalOperator) conditions.push(item.tempLogicalOperator);
            conditions.push(item.pushConditions);
        });
        return conditions;
    };

    store.changeDataType = (row) => {
        row.pushConditions.operator = CompareOperators.EQUAL;
        row.pushConditions.values = [];
        row.tempSelectModel = "all";
        row.tempUsers = "";
        if (row.pushConditions.dataType === ConditionsDataTypeEnum.USAGE_DAY) {
            row.pushConditions.operator = CompareOperators.GREATER_THAN_OR_EQUAL;
            row.pushConditions.values = ["3"];
        }
    };

    store.setUserValueProxy = (row) => ({
        get: () => row.tempUsers,
        set: (val) => {
            row.tempUsers = val;
            row.pushConditions.values = val
                ? String(val)
                    .split(";")
                    .map((v) => v.trim())
                    .filter(Boolean)
                : [];
        }
    });

    store.initPushConditionsConfig = async () => {
        const [channelsRes, rolesRes, versionsRes] = await Promise.all([
            api.getChannels({ page: 1, pageSize: 2000, clientType: "galaxy" }),
            api.getPowerRole(),
            api.getVersions({ page: 1, pageSize: 2000, clientType: "galaxy" })
        ]);

        const channels = (channelsRes.data && channelsRes.data.items) ? channelsRes.data.items : [];
        const roles = rolesRes.data || [];
        const versions = (versionsRes.data && versionsRes.data.items) ? versionsRes.data.items : [];

        store.pushConditionsConfig = {
            [ConditionsDataTypeEnum.CHANNEL]: {
                compareOperators: [CompareOperators.EQUAL, CompareOperators.NOT_EQUAL],
                models: [
                    { label: "全渠道", value: "all" },
                    {
                        label: "指定渠道",
                        value: "specified",
                        list: channels.map((item) => ({ label: item.name, value: item.code }))
                    }
                ]
            },
            [ConditionsDataTypeEnum.USER_ROLE]: {
                compareOperators: [CompareOperators.EQUAL, CompareOperators.NOT_EQUAL],
                models: [
                    { label: "全部用户", value: "all" },
                    {
                        label: "指定用户",
                        value: "specified",
                        list: roles.map((item) => ({ label: item.name, value: item.value }))
                    }
                ]
            },
            [ConditionsDataTypeEnum.USER]: {
                compareOperators: [CompareOperators.EQUAL, CompareOperators.NOT_EQUAL]
            },
            [ConditionsDataTypeEnum.APP_VERSION]: {
                compareOperators: [CompareOperators.EQUAL, CompareOperators.NOT_EQUAL, CompareOperators.BETWEEN],
                models: versions.map((item) => ({ label: item.name, value: item.version }))
            },
            [ConditionsDataTypeEnum.USAGE_DAY]: {
                compareOperators: [],
                models: [{ label: "下载使用大于等于 3 天的用户", value: "3" }]
            }
        };
    };

    return store;
}


